module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAA3klEQVQoU4XRP4rCUBAG8G8mVYrtLbRVSBPyHhYpRPACegGx8ha71e4pxMoT6AkULGXyp9RWPcHCBgIvb0lQEZU41WP4fcMwj7TWRwBNvClr7ZmUUjMimr7DAObkeV7Ddd0DgI+awG+WZW0qQRAEn8z8XYO/ROSnwmEYunme7wG0XgROADoi8lfhy/QxMy8ecVEUkziOq/4Nl2+l1I6I9DVgrZUoiroA7CMud+8z8/oyxBpjBkmSbK7h+8lVT2u9BDAEsBKR0f1aT9j3/bbjOFtjTC9N0/Kkt3rCdZ/zDy7xQlBBgUELAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/xiasanjiaoxing.png
// module id = bgB4
// module chunks = 3